import { VortexUICurrentAttempt } from "../../../../../components/ui/hud/VortexUI";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { globals } from "../../../../../misc/globals";
import { registerBvmAttempt, forceRerenderUI } from "../../../../../misc/tools";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresBvmMainConfig, GeneralProceduresBvmPart1Config } from "../GeneralProceduresBvmMain";

export default class GeneralProceduresBvmPart1 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresBvmPart1Config {
		return this.scenarioConfig.part1Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private onAbort: () => void, private id: string, private scenarioConfig: GeneralProceduresBvmMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		if(!this.config.isToolEnabled || (this.config.isToolEnabled && this.config.isToolEnabled())) {
			context.step1ShowAttemptWindow();
		} else {
			context.scenario.toolbagId = context.scenario.uiWrapper.displayToolbag({
				isDisabled: false
			}, context.scenario.toolbagId);
			context.scenarioConfig.onDone();
		}
	}
	public step1ShowAttemptWindow() {
		const context = this;
		context.scenario.uiWrapper.displayBVMMakeAttemptUI({
            onMakeAttemptClicked: (isNPAClicked: boolean, isOPAClicked: boolean) => {
				registerBvmAttempt(context.scenario);
				context.scenario.uiWrapper.destroyAllUIInstances();
				forceRerenderUI(constants.uiNames.BVMMakeAttemptUI);
				
				if(context.config.onMakeAttemptClicked) {
					context.config.onMakeAttemptClicked(isNPAClicked, isOPAClicked)
				}
                context.step2ShowAttemptWindow();
            },
            onAbortedClicked: () => {
				context.scenario.uiWrapper.destroyAllUIInstances();
				forceRerenderUI(constants.uiNames.BVMMakeAttemptUI);
				
				if(context.config.onAbortClicked) {
					context.config.onAbortClicked()
				}

				context.onAbort();
            }
        })
	}

	public step2ShowAttemptWindow() {
		const context = this;
		context.scenario.uiWrapper.displayBVMAttemptUI({
			onNextClicked: (isOneHanded: boolean) => {
				if(context.config.onChooseHandNextClicked) {
					context.config.onChooseHandNextClicked(isOneHanded)
				}
				
				// context.scenario.addScore(context.scenario.bvmOneHandedUIPoints);
				context.onDone();
			}
        })
	}
}
